<template>
  <div class="step-container">
    <div class="row center">
      <h3 class="step-header">4. Select your plan</h3>
    </div>
    <div class="row center">
      <h4 class="step-sub-header">All plans include an annual service</h4>
    </div>
    <div class="row">
      <div class="plans">
        <plan-card v-for="plan in plans" :key="plan.plan_name" :plan="plan" :features="features" @select="submit(plan)" :upcost="upcost"></plan-card>
      </div>
    </div>
    <div class="row center back">
      <span @click="$emit('back')">Back</span>
    </div>
  </div>
</template>

<script>
import PlanCard from "../PlanCard";

export default {
  name: "StepFour",
  props: {
    plans: {
      type: Array,
      default(){
        return [];
      }
    },
    features: {
      type: Array,
      default(){
        return [];
      }
    },
    upcost: {
      type: Number,
      default: 0,
    },
    base: {
      type: String,
      required: true,
    },
  },
  components: {
    PlanCard,
  },
  data() {
    return {
      guarantee: 'unknown',
      ownership: 'homeowner',
      fuel: 'gas',
      selected: null,
    }
  },
  methods: {
    submit(plan){
      this.$emit('submit', plan);
    },
  }
}
</script>

<style lang="scss" scoped>
.plans{
  margin-top: 1rem;
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/StepFour.vue